"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ManageListActions = void 0;
var ManageListActions;
(function (ManageListActions) {
    ManageListActions["CREATE_LIST"] = "CREATE_LIST";
    ManageListActions["UPDATE_LIST"] = "UPDATE_LIST";
    ManageListActions["DELETE_LIST"] = "DELETE_LIST";
    ManageListActions["CREATE_GROUP"] = "CREATE_GROUP";
    ManageListActions["UPDATE_GROUP"] = "UPDATE_GROUP";
    ManageListActions["DELETE_GROUP"] = "DELETE_GROUP";
    ManageListActions["CREATE_ITEMS"] = "CREATE_ITEMS";
    ManageListActions["UPDATE_ITEMS"] = "UPDATE_ITEMS";
    ManageListActions["DELETE_ITEMS"] = "DELETE_ITEMS";
    ManageListActions["MOVE_ITEMS"] = "MOVE_ITEMS";
    ManageListActions["COPY_ITEMS"] = "COPY_ITEMS";
    ManageListActions["REPLACE_ITEMS"] = "REPLACE_ITEMS";
    ManageListActions["MOVE_ITEMS_SAME_LIST"] = "MOVE_ITEMS_SAME_LIST";
})(ManageListActions = exports.ManageListActions || (exports.ManageListActions = {}));
__exportStar(require("./errors"), exports);
__exportStar(require("./list/create-list"), exports);
__exportStar(require("./list/edit-list"), exports);
__exportStar(require("./list/delete-list"), exports);
__exportStar(require("./list/copy-list"), exports);
__exportStar(require("./list/import-list"), exports);
__exportStar(require("./list/import-aog-list"), exports);
__exportStar(require("./list/get-modifiable-list-by-name"), exports);
__exportStar(require("./list/mass-delete-list"), exports);
__exportStar(require("./list/get-accessible-list"), exports);
__exportStar(require("./listGroup/create-list-group"), exports);
__exportStar(require("./listGroup/delete-list-group"), exports);
__exportStar(require("./listGroup/edit-list-group"), exports);
__exportStar(require("./listItems"), exports);
__exportStar(require("./listItems/update-items"), exports);
__exportStar(require("./listItems/create-items"), exports);
__exportStar(require("./listItems/replace-items"), exports);
__exportStar(require("./listItems/delete-items"), exports);
__exportStar(require("./listItems/copy-items"), exports);
__exportStar(require("./listItems/copy-items-across-lists"), exports);
__exportStar(require("./listItemNote/list-item-note-request"), exports);
